import React from "react";

function Faqs() {
	return (
	<div
  style={{
    width: '100%',
    height: '100vh',
    backgroundColor: '#ffffff', // background around iframe
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    margin: 0,
  }}
>
  <iframe
    src="https://cdn.travelwings.com/assets/corp/documents/faqs.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=80"
    style={{
      width: '100%',
      height: '100%',
      border: 'none',
    }}
    title="TravelWings FAQ"
  />
</div>





	);
}

export default Faqs;

